/** Hyphen and dash characters that look like an ASCII "-" but are not. */
const DASH_LOOKALIKES = /[\u2010-\u2015\u2212]/g;

/**
 * Folds typographic dashes to an ASCII hyphen so a pasted label still matches the canonical
 * option lists, which spell ranges with "-".
 *
 * Shared by eligibility (gatekeeper) and ranking (scoring engine): if the two disagreed on
 * which characters make two labels equal, a CDMO could be matchable by one and not the other.
 */
export const withAsciiDashes = (label: string): string => label.replace(DASH_LOOKALIKES, '-');
